/**
 * Testimonials section
 */
(function testimonialsFrontend($, window) {
    $(document).on('cms.ready', ready);
    // $(document).ready(ready);

    let logged_in = false; // Nice-to-have: Logged in as a Contenda variable.
    let slickSettings = {
        mobileFirst: true,
        adaptiveHeight: true,
        slidesToShow: 1,
        swipeToSlide: true,
        responsive: [{
            breakpoint: 767, // >767 (tablet_portrait)
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
            }
        },{
            breakpoint: 1023, // >1023
            settings: 'unslick'
            // settings: {
            //     slidesToShow: 4,
            //     slidesToScroll: 0,
            // }
        }]
    };

    function ready() {
        logged_in = $('body.logged-in').length;

        if(logged_in) {
            // Set up intersect listener on document since that's the only way we can listen to newly added elements
            $(document).on('cms.intersect', '.sectionTestimonials', function(evt, entry, $elm) {
                setupSection(0, $elm);
                loadTestimonials(evt, entry, $elm);
            });
        } else {
            let $sections = $('.sectionTestimonials');
            $sections.each(setupSection);
            // Set up intersect listener on section (delay GET until section is visible)
            $sections.on('cms.intersect', loadTestimonials);
        }
    }

    function setupSection(i, elm) {
        let $elm = $(elm),
            $template = $('.testimonials__template', $elm).detach();
        // We want to refer to the template later, so save a reference on the section
        $elm.data('_template', $template);
    }

    function loadTestimonials(event, entry, $section) {
        let ids = [],
            $template = $section.data('_template'),
            $testimonials = $('.testimonials__elements', $section),
            $children = $testimonials.children('.testimonials__element');

        // Deal with placeholder items
        let $nonitems = $children.filter('[data-testimonial-id="-1"]');
        if(logged_in) {
            $nonitems.each(function(idx, elm) {
                addPlaceholderItem(null, idx, $section);
            });
        } else {
            $nonitems.remove();
        }

        $children.not($nonitems).each(function(idx, elm) {
            ids.push($(elm).data('testimonial-id'));
        });

        if(ids.length > 1) {
            $.get(
                'api/testimonial/idlist',
                { testimonialIds: ids },
                function(data) {
                    $.each(data.rows, function(i, testimonial) {
                        let $child = $testimonials.find('[data-testimonial-id='+testimonial.id+']');

                        let $memberTemplate = $template.clone();
                        $memberTemplate.removeClass('testimonials__template');

                        for(let key in testimonial) {
                            let value = testimonial[key];
                            setValue($memberTemplate, key, value);
                        }
                        $memberTemplate.appendTo($child);
                    });

                    $section.trigger('sectionTestimonials.frontend.ready');
                }
            );
        } else {
            $section.trigger('sectionTestimonials.frontend.ready');
        }

        if(logged_in) {
            $(document).on('sectionTestimonials.addItem', function addItem(e, idx) {
                addPlaceholderItem(e, idx, $section);
            });

            $(document).on('sectionTestimonials.removeItem', function removeItem(e, obj) {
                $section.trigger('sectionTestimonials.frontend.update');
            });

            $(document).on('sectionTestimonials.updateItem', function updateItem(e, obj) {
                let item = obj.item,
                    idx = obj.idx;
                let $child = $testimonials.children().eq(idx);

                if(!item.id) return addPlaceholderItem(e, idx, $section);

                $child.empty(); // Remove old content
                $.get(
                    'api/testimonial/' + item.id,
                    function(testimonial) {
                        let $memberTemplate = $template.clone();
                        $memberTemplate.removeClass('testimonials__template');

                        for(let key in testimonial) {
                            let value = testimonial[key];
                            setValue($memberTemplate, key, value);
                        }

                        $memberTemplate.appendTo($child); // Add new content

                        $section.trigger('sectionTestimonials.frontend.update');
                    }
                );

            });
        }
    }

    function setValue($memberTemplate, key, value) {
        if($.isArray(value)) {
            for(let _key in value) {
                setValue($memberTemplate, key + '.' + _key, value[_key]);
            }
            return;
        }

        let elm = $memberTemplate.find('[data-field="' + key + '"]');

        switch (key) {
            case 'personImageUrl':
                elm.css('backgroundImage', 'url("'+value+'?opt=true")');
                break;
            case 'content':
                elm.html(value.replace(/(?:\r\n|\r|\n)/g, '<br>'));
                break;
            default:
                elm.html(value);
        }
    }

    function addPlaceholderItem(e, idx, $section) {
        Contenda.log('addPlaceholderItem', e, idx, $section);
        let $testimonials = $('.testimonials__elements', $section),
            $child = $testimonials.children().eq(idx),
            $template = $section.data('_template');
        $child.empty(); // Remove existing content

        let $memberTemplate = $template.clone();
        $memberTemplate.removeClass('testimonials__template');

        let testimonial = {
            'personName': 'Name',
            'personDescription': 'Description',
            'content': 'Quote'
        };
        for(let key in testimonial) {
            let value = testimonial[key];
            setValue($memberTemplate, key, value);
        }

        $memberTemplate.appendTo($child);

        $section.trigger('sectionTestimonials.frontend.update');
    }

    function reinitializeSlick($slider) {
        // console.log('reinitializing Slick', $slider);
        // destroy slick and remove all depending classes
        $slider.hide();
        if($slider.hasClass('slick-initialized')) {
            $slider.slick('unslick');
            $slider.siblings('.testimonials__navigation').empty();
        }
        setTimeout( function() {
            $slider.show();
            $slider.slick(slickSettings);
        }, 100);
    }

    $(document).on('sectionTestimonials.frontend.ready', function frontendReady(evt) {
        let $section = $(evt.target);
        slickSettings.prevArrow = $section.find('.testimonials__prev').detach().get(0).outerHTML;
        slickSettings.nextArrow = $section.find('.testimonials__next').detach().get(0).outerHTML;
        slickSettings.appendArrows = $section.find('.testimonials__navigation');

        if(logged_in) {
            // Clone angular container and hide the original one (to keep bindings)
            let $testimonials = $section.find('.testimonials__elements'),
                $parent = $testimonials.parent(),
                $clone = $testimonials.clone();
            $testimonials.hide();

            $clone.appendTo($parent);

            reinitializeSlick($clone);

            $section.on('sectionTestimonials.frontend.update', function() {

                if($clone.hasClass('slick-initialized')) {
                    $clone.slick('unslick');
                    $testimonials.siblings('.testimonials__navigation').empty();
                }

                $clone.remove(); // Destroy old clone
                $clone = $testimonials.clone(); // Create new clone
                $clone.addClass('clone');
                $clone.appendTo($parent);

                reinitializeSlick($clone);
            });
        } else {
            let $slider = $section.find('.testimonials__elements');

            // Remove slides that do not have an id
            // $slider.find('[data-testimonial-id="-1"]').remove();
            reinitializeSlick($slider);
        }
    });

})(jQuery, window);